// Mirrors the AUTH_REDIRECT_FLAG guard in UserContext to avoid redirect loops.
const AUTH_REDIRECT_FLAG = "authRedirectAttempted";

const redirectToAmbassador = () => {
  if (window.location.hostname === "localhost") {
    console.warn("Skipping Ambassador auth redirect on localhost.");
    return;
  }
  if (sessionStorage.getItem(AUTH_REDIRECT_FLAG)) {
    console.error("Already attempted an Ambassador auth redirect this session. Aborting to avoid a redirect loop.");
    return;
  }
  sessionStorage.setItem(AUTH_REDIRECT_FLAG, "true");
  window.location.href = process.env.REACT_APP_ATLAS_AMBASSADOR_BASE;
};

export default redirectToAmbassador;
